import { render, staticRenderFns } from "./hidden-editor.vue?vue&type=template&id=d798e8e2&scoped=true&"
import script from "./hidden-editor.vue?vue&type=script&lang=js&"
export * from "./hidden-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d798e8e2",
  null
  
)

export default component.exports